export default __webpack_public_path__ + "static/resume-6573784f38433b29889c2441e093f4ef.pdf";